import React, { useState, useEffect } from 'react';
import axios from 'axios';

const statusColor = (status) => {
  switch (status) {
    case 'pending': return 'bg-yellow-100 text-yellow-800';
    case 'confirmed': return 'bg-green-100 text-green-800';
    case 'cancelled': return 'bg-red-100 text-red-800';
    case 'rejected': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

const formatDateTime = (isoString) => {
  const d = new Date(isoString);
  return d.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

const ProviderBookingTable = ({ bookings }) => {
  const [localBookings, setLocalBookings] = useState([]);

  useEffect(() => {
    if (Array.isArray(bookings)) {
      setLocalBookings(bookings.map(b => ({ ...b, _updating: false })));
    }
  }, [bookings]);

  const updateBookingStatus = async (id, action) => {
    setLocalBookings(prev =>
      prev.map(b => (b.id === id ? { ...b, _updating: true } : b))
    );

    try {
      const token = localStorage.getItem('token');
      await axios.post(`/api/provider/bookings/${id}/${action}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setLocalBookings(prev =>
        prev.map(b =>
          b.id === id
            ? { ...b, status: action === 'confirm' ? 'confirmed' : 'rejected', _updating: false }
            : b
        )
      );
    } catch (err) {
      console.error(`❌ Failed to ${action} booking:`, err);
      alert(`Error: Could not ${action} booking.`);
      setLocalBookings(prev =>
        prev.map(b => (b.id === id ? { ...b, _updating: false } : b))
      );
    }
  };

  return (
    <div className="bg-white rounded-xl shadow p-6 mt-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Recent Bookings</h2>
      {localBookings.length === 0 ? (
        <p className="text-gray-500">No bookings found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className="border-b text-gray-500 uppercase text-xs">
              <tr>
                <th className="px-4 py-2">Booking ID</th>
                <th className="px-4 py-2">License Plate</th>
                <th className="px-4 py-2">Phone</th>
                <th className="px-4 py-2">Status</th>
                <th className="px-4 py-2">Payment</th>
                <th className="px-4 py-2">Time</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {localBookings.map((b) => (
                <tr key={b.id} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{b.id}</td>
                  <td className="px-4 py-3">{b.license_plate}</td>
                  <td className="px-4 py-3">{b.phone_number}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColor(b.status)}`}>
                      {b.status}
                    </span>
                  </td>
                  <td className="px-4 py-3">{b.payment_status}</td>
                  <td className="px-4 py-3">
                    {formatDateTime(b.start_time)} → {formatDateTime(b.end_time)}
                  </td>
                <td className="px-4 py-3">
                    {b.status === 'pending' ? (
                      <div className="flex space-x-2">
                        <button
                          onClick={() => updateBookingStatus(b.id, 'confirm')}
                          disabled={b._updating}
                          className={`flex-1 px-3 py-1 text-xs rounded text-white ${
                            b._updating ? 'bg-blue-300' : 'bg-blue-500 hover:bg-blue-600'
                          }`}
                        >
                          {b._updating ? 'Confirming...' : 'Confirm'}
                        </button>
                        <button
                          onClick={() => updateBookingStatus(b.id, 'reject')}
                          disabled={b._updating}
                          className={`flex-1 px-3 py-1 text-xs rounded text-white ${
                            b._updating ? 'bg-red-300' : 'bg-red-500 hover:bg-red-600'
                          }`}
                        >
                          {b._updating ? 'Rejecting...' : 'Reject'}
                        </button>
                      </div>
                    ) : (
                      <span className="text-gray-400 text-xs">—</span>
                    )}
                  </td> 
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProviderBookingTable;
